import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import { Translate, I18n } from 'react-redux-i18n';
import Button from 'components/Form/Button';
import FlexGroup from 'components/FlexGroup';
import { toggleErrorDialog } from 'actions';
import { useDeleteFiltersMutation } from 'redux/hook/useFilter';

const FilterImportModal = ({
    selectedFilters,
    show,
    onClose,
}) => {
    const dispatch = useDispatch();
    const [inProgress, setInProgress] = useState(false);
    const [deleteFilters] = useDeleteFiltersMutation();


    const handleRemove = async e => {
        if (selectedFilters.length) {
            setInProgress(true);
            const { error } = await deleteFilters({ filter_ids: selectedFilters});
            if (error) {
                const { status } = error;
                if (status === 404 || status === 400) {
                    dispatch(toggleErrorDialog(I18n.t(`filters.delete_error_${ status }`)));
                }
                else {
                    dispatch(toggleErrorDialog(I18n.t('general_error_message')));
                }
                setInProgress(false);
            }
            else {
                setInProgress(false);
                onClose();
            }

        }
    }
    return (
        <>
            {
                show ? (
                    <Modal
                        className="filter-remove-modal"
                        title={ I18n.t('filters.remove') }
                        onClose={ onClose }
                    >
                        <FlexGroup className="message">{ I18n.t('filters.confirm_remove') }</FlexGroup>
                        <FlexGroup end gap>
                            <Button type="button" className="btn-cancel" onClick={ onClose } outline>
                                <Translate value="cancel" />
                            </Button>
                            <Button color="primary" type="button" disabled={ inProgress } onClick={ handleRemove }>
                                <Translate value="filters.remove" />
                            </Button>
                        </FlexGroup>
                    </Modal>
                ) : null
            }
        </>
    );
};

FilterImportModal.propTypes = {
    selectedFilters: PropTypes.arrayOf(PropTypes.string),
    show: PropTypes.bool,
    onClose: PropTypes.func,
};
FilterImportModal.defaultProps = {
    selectedFilters: [],
    show: false,
    onClose: () => {},
};

export default FilterImportModal;
